import { Link } from "react-router-dom";

export const LogoMark = ({ className = "h-9 w-9", light = false }) => (
  <svg
    className={className}
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <circle
      cx="18"
      cy="18"
      r="15"
      stroke={light ? "currentColor" : "#1B4D3E"}
      strokeWidth="2.5"
      strokeDasharray="1 3"
    />
    <path
      d="M10 20C12 14 16 11 18 11C20 11 24 14 26 20C22 21.5 18 20.5 18 20.5C18 20.5 14 21.5 10 20Z"
      fill="#C85A32"
    />
    <path
      d="M18 11V25"
      stroke={light ? "currentColor" : "#1B4D3E"}
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const Logo = ({ light = false, onClick }) => (
  <Link
    to="/"
    onClick={onClick}
    data-testid="logo-home-link"
    className={`flex min-w-0 shrink-0 items-center gap-2.5 no-underline sm:gap-3 ${
      light ? "text-band-foreground" : "text-foreground"
    }`}
  >
    <LogoMark light={light} className="h-8 w-8 shrink-0 sm:h-10 sm:w-10" />
    <span className="flex min-w-0 flex-col leading-[1.08]">
      <span className="whitespace-nowrap font-display text-[0.8rem] font-extrabold tracking-wide sm:text-[0.98rem]">
        <span className="hidden sm:inline">KAMALAMA FOUNDATION</span>
        <span className="sm:hidden">
          KAMALAMA
          <br />
          FOUNDATION
        </span>
      </span>
      <span
        className={`hidden truncate text-[0.72rem] sm:block ${
          light ? "text-band-muted" : "text-muted-foreground"
        }`}
      >
        Kauaʻi takes care of Kauaʻi.
      </span>
    </span>
  </Link>
);
